import { ARTICLES } from './articles';
import { CORE_MESSAGES, SCHOLARSHIP_DATE, SCHOLARSHIP_LABEL } from './data';

export { CORE_MESSAGES, SCHOLARSHIP_DATE, SCHOLARSHIP_LABEL };

const kickers = { 0: 'Student & Talent', 1: 'Enterprise & Technology', 2: 'DITEC Perspective' };
const featured = ['future-of-the-graduate', 'rise-of-portfolio-verified-talent', 'learning-a-skill-vs-demonstrating-it'];

export const ARTICLES_DATA = featured.map((slug, i) => {
  const a = ARTICLES.find((x) => x.slug === slug);
  return { ...a, kicker: kickers[i] };
});
